export const FAILED_LOGIN = "FAILED_LOGIN";
export const PERFORM_LOGOUT = "PERFORM_LOGOUT";

export const ADD_ERRORS = "ADD_ERRORS";
export const CLEAN_ERRORS = "CLEAN_ERRORS";

export const UPDATE_USER = "UPDATE_USER";
export const ADD_ADMIN_USERS = "ADD_ADMIN_USERS";
export const ADD_LANDING_DATA = "ADD_LANDING_DATA";
export const ADD_LANDING_DATA_USER = "ADD_LANDING_DATA_USER";
export const ADD_CONFIRMATION_USERS = "ADD_CONFIRMATION_USERS";

export const ADD_ABOUT_DATA = "ADD_ABOUT_DATA";
export const ADD_ABOUT_DATA_USER = "ADD_ABOUT_DATA_USER";

export const ADD_WEBINARS = "ADD_WEBINARS";
export const SET_WEBINARS = "SET_WEBINARS";
export const UPDATE_WEBINAR = "UPDATE_WEBINAR";
export const SET_TEMP_WEBINAR = "SET_TEMP_WEBINAR";
export const ADD_USERS_WEBINARS = "ADD_USERS_WEBINARS";
export const SET_USERS_WEBINARS = "SET_USERS_WEBINARS";

export const CLEAN_WEBINARS = "CLEAN_WEBINARS";
export const CLEAN_USERS_WEBINARS = "CLEAN_USERS_WEBINARS";
export const USER_WEBINARS_AVAILABLE_YEARS = "USER_WEBINARS_AVAILABLE_YEARS";
export const ADD_ADMIN_DASHBOARD_USERS = "ADD_ADMIN_DASHBOARD_USERS";
export const ADD_ADMIN_USRES_WEBINARS = "ADD_ADMIN_USRES_WEBINARS_SAGA";
export const ADD_ADMIN_USRES_WEBINARS_SESSIONS =
  "ADD_ADMIN_USRES_WEBINARS_SESSIONS";
export const ADD_ADMIN_USERS_NEWSLETTER_WEBINARS =
  "ADD_ADMIN_USERS_NEWSLETTER_WEBINARS";

export const ADD_ADMIN_WEBINARS = "ADD_ADMIN_WEBINARS";
export const ADD_ADMIN_DASHBOARD_WEBINARS = "ADD_ADMIN_DASHBOARD_WEBINARS";

export const ADD_SUBSCRIPTIONS = "ADD_SUBSCRIPTIONS";

export const ADD_VIMEO_VIDEO_DATA = "ADD_VIMEO_VIDEO_DATA";

export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const SET_QUIZ_STATUS = "SET_QUIZ_STATUS";

export const ADD_HOSPITAL_SUGGESTIONS = "ADD_HOSPITAL_SUGGESTION";
export const NEW_HOSPITAL_SUGGESTION = "NEW_HOSPITAL_SUGGESTION";
export const ADD_COUNTY_SUGGESTIONS = "ADD_COUNTY_SUGGESTIONS";
export const ADD_BRANCH_SUGGESTIONS = "ADD_BRANCH_SUGGESTIONS";
export const ADD_COUNTRIES_SUGGESTIONS = "ADD_COUNTRIES_SUGGESTIONS";
export const ADD_SPONSOR_SUGGESTIONS = "ADD_SPONSOR_SUGGESTIONS";
export const ADD_PARTNER_SUGGESTIONS = "ADD_PARTNER_SUGGESTIONS";
export const ADD_SPONSOR_USERS_SUGGESTIONS = "ADD_SPONSOR_USERS_SUGGESTIONS";

export const SET_EDIT_USER = "SET_EDIT_USER";

export const START_REQUEST = "START_REQUEST";
export const END_REQUEST = "END_REQUEST";

export const SET_PROFILE_CONFIRMATION = "SET_PROFILE_CONFIRMATION";
export const UNSUBSCRIBE_SAGA = "UNSUBSCRIBE_SAGA";

export const ADD_SPONSORS = "ADD_SPONSORS";
export const CLEAN_SPONSORS = "CLEAN_SPONSORS";
export const SET_TEMP_SPONSOR = "SET_TEMP_SPONSOR";
export const ADD_ADMIN_SPONSORS = "ADD_ADMIN_SPONSORS";

export const ADD_PARTNERS = "ADD_PARTNERS";
export const CLEAN_PARTNERS = "CLEAN_PARTNERS";
export const SET_TEMP_PARTNER = "SET_TEMP_PARTNER";
export const ADD_ADMIN_PARTNERS = "ADD_ADMIN_PARTNERS";
export const ADD_ASSIGNED_USERS = "ADD_ASSIGNED_USERS";
export const ADD_NOVONORDISK_USERS = "ADD_NOVONORDISK_USERS";
export const CREATE_DISCIPLINE_SAGA = "CREATE_DISCIPLINE_SAGA";
export const LOAD_ADMIN_DISCIPLINES_SAGA = "LOAD_ADMIN_DISCIPLINES_SAGA";
export const ADD_ADMIN_DISCIPLINES = "ADD_ADMIN_DISCIPLINES";
export const UPDATE_DISCIPLINE_SAGA = "UPDATE_DISCIPLINE_SAGA";
export const DELETE_DISCIPLINE_SAGA = "DELETE_DISCIPLINE_SAGA";
export const ADMIN_DELETE_DISCIPLINES_SAGA = "ADMIN_DELETE_DISCIPLINES_SAGA";
export const ADD_DISCIPLINES = "ADD_DISCIPLINES";
export const ADD_NEW_DISCIPLINES = "ADD_NEW_DISCIPLINES";
export const LOAD_DISCIPLINES_SAGA = "LOAD_DISCIPLINES_SAGA";
export const LOAD_NEW_DISCIPLINES_SAGA = "LOAD_NEW_DISCIPLINES_SAGA";
export const SEND_CONFIRMATION_USERS_SAGA = "SEND_CONFIRMATION_USERS_SAGA";
export const LOAD_DISCIPLINE_SAGA = "LOAD_DISCIPLINE_SAGA";
export const SET_TEMP_DISCIPLINE = "SET_TEMP_DISCIPLINE";
export const CLEAN_DISCIPLINES = "CLEAN_DISCIPLINES";
export const ADD_SEARCH_DISCIPLINES = "ADD_SEARCH_DISCIPLINES";
export const LOAD_WEBINAR_SUBSCRIPTION = "LOAD_WEBINAR_SUBSCRIPTION";
export const PUT_WEBINAR_SUBSCRIPTION_SAGA = "PUT_WEBINAR_SUBSCRIPTION_SAGA";
export const POST_WEBINAR_SUBSCRIPTION_SAGA = "POST_WEBINAR_SUBSCRIPTION_SAGA";
export const SEARCH_WEBINARS = "SEARCH_WEBINARS";
export const SEARCH_WEBINARS_TERMS = "SEARCH_WEBINARS_TERMS";
export const SAVE_SEARCHED_WEBINARS = "SAVE_SEARCHED_WEBINARS";
export const SAVE_SEARCHED_WEBINARS_TERMS = "SAVE_SEARCHED_WEBINARS_TERMS";
export const LOAD_WEBINARS_COMPLETE = "LOAD_WEBINARS_COMPLETE";
// export const SEND_DISCIPLINES_APPROVE_SAGA = 'SEND_DISCIPLINES_APPROVE_SAGA';
// export const SEND_DISCIPLINES_REJECT_SAGA = 'SEND_DISCIPLINES_REJECT_SAGA';

export const GET_STATS = "GET_STATS";
export const GET_STATS_SUCCESS = "GET_STATS_SUCCESS";
export const GET_STATS_NEXT_PAGE_SUCCESS = "GET_STATS_NEXT_PAGE_SUCCESS";
export const GET_STATS_ERROR = "GET_STATS_ERROR";
export const GET_LIVE_ATTENDEES = "GET_LIVE_ATTENDEES";
export const GET_LIVE_ATTENDEES_SUCCESS = "GET_LIVE_ATTENDEES_SUCCESS";
export const GET_LIVE_ATTENDEES_ERROR = "GET_LIVE_ATTENDEES_ERROR";
export const GET_RECORDED_VIEWS = "GET_RECORDED_VIEWS";
export const GET_RECORDED_VIEWS_SUCCESS = "GET_RECORDED_VIEWS_SUCCESS";
export const GET_RECORDED_VIEWS_ERROR = "GET_RECORDED_VIEWS_ERROR";
export const GET_WEBINAR_DATA = "GET_WEBINAR_DATA";
export const GET_WEBINAR_DATA_SUCCESS = "GET_WEBINAR_DATA_SUCCESS";
export const GET_WEBINAR_DATA_ERROR = "GET_WEBINAR_DATA_ERROR";

export const ADD_CALENDAR_BOOKINGS = "ADD_CALENDAR_BOOKINGS";
export const ADD_CALENDAR_BOOKING = "ADD_CALENDAR_BOOKING";
export const ADD_BOOKING_HOLIDAYS = "ADD_BOOKING_HOLIDAYS";
export const LOAD_CALENDAR_BOOKINGS = "LOAD_CALENDAR_BOOKINGS";
export const CREATE_CALENDAR_BOOKING = "CREATE_CALENDAR_BOOKING";
export const UPDATE_CALENDAR_SAGA = "UPDATE_CALENDAR_SAGA";
export const LOAD_ADMIN_CALENDAR_BOOKINGS = "LOAD_ADMIN_CALENDAR_BOOKINGS";
export const LOAD_SPONSOR_BOOKINGS = "LOAD_SPONSOR_BOOKINGS";
export const ADD_ADMIN_CALENDAR_BOOKINGS = "ADD_ADMIN_CALENDAR_BOOKINGS";
export const ADMIN_BOOKINGS_APPROVE_REJECT = "ADMIN_BOOKINGS_APPROVE_REJECT";
export const PUT_ADMIN_CALENDAR_BOOKING = "PUT_ADMIN_CALENDAR_BOOKING";
export const LOAD_CALENDAR_BOOKING = "LOAD_CALENDAR_BOOKING";
export const ADD_CALENDAR_EDIT_BOOKING = "ADD_CALENDAR_EDIT_BOOKING";
export const ADD_CALENDAR_SPONSOR_BOOKINGS = "ADD_CALENDAR_SPONSOR_BOOKINGS";

export const GET_SUPERHOST = "GET_SUPERHOST";
export const GET_SUPERHOSTS = "GET_SUPERHOSTS";
export const CREATE_SUPERHOST = "CREATE_SUPERHOST";
export const SAVE_SUPERHOSTS = "SAVE_SUPERHOSTS";
export const UPDATE_SUPERHOST = "UPDATE_SUPERHOST";
export const DELETE_SUPERHOSTS = "DELETE_SUPERHOSTS";
export const SET_SUPERHOST = "SET_SUPERHOST";
export const CLEAN_SUPERHOST = "CLEAN_SUPERHOST";

export const GET_STUDYGROUP = "GET_STUDYGROUP";
export const GET_ADMIN_STUDYGROUP = "GET_ADMIN_STUDYGROUP";
export const GET_STUDYGROUPS = "GET_STUDYGROUPS";
export const GET_STUDYGROUPS_INFINITE = "GET_STUDYGROUPS_INFINITE";
export const GET_STUDYGROUPS_ADMIN = "GET_STUDYGROUPS_ADMIN";
export const CREATE_STUDYGROUP = "CREATE_STUDYGROUP";
export const SAVE_STUDYGROUPS = "SAVE_STUDYGROUPS";
export const SAVE_STUDYGROUPS_INFINITE = "SAVE_STUDYGROUPS_INFINITE";
export const UPDATE_STUDYGROUP = "UPDATE_STUDYGROUP";
export const UPDATE_STUDYGROUP_SUPERHOST = "UPDATE_STUDYGROUP_SUPERHOST";

export const DELETE_STUDYGROUPS = "DELETE_STUDYGROUPS";
export const SET_STUDYGROUP = "SET_STUDYGROUP";
export const CLEAN_STUDYGROUP = "CLEAN_STUDYGROUP";

export const GET_GROUP_MEMBERS = "GET_GROUP_MEMBERS";
export const SET_GROUP_MEMBERS = "SET_GROUP_MEMBERS";

export const LOAD_GROUP_MATERIAL = "LOAD_GROUP_MATERIAL";
export const GET_GROUP_MATERIAL = "GET_GROUP_MATERIAL";
export const SET_GROUP_MATERIAL = "SET_GROUP_MATERIAL";
export const SET_GROUP_MATERIAL_INFINITY = "SET_GROUP_MATERIAL_INFINITY";
export const UPDATE_GROUP_MATERIALS_AFTER_DELETE =
  "UPDATE_GROUP_MATERIALS_AFTER_DELETE";
export const CREATE_STUDY_GROUP_MATERIALS = "CREATE_STUDY_GROUP_MATERIALS";
export const CLEAR_STUDY_GROUP_MATERIALS = "CLEAR_STUDY_GROUP_MATERIALS";
export const DELETE_STUDY_GROUP_MATERIAL = "DELETE_STUDY_GROUP_MATERIAL";
export const GET_STUDY_GROUP_INVITES = "GET_STUDY_GROUP_INVITES";
export const SET_STUDY_GROUP_INVITES = "SET_STUDY_GROUP_INVITES";
export const GET_STUDY_GROUP_STATISTIC = "GET_STUDY_GROUP_STATISTIC";
export const SET_STUDY_GROUP_STATISTIC = "SET_STUDY_GROUP_STATISTIC";
export const GET_STUDY_GROUP_WEBINARS = "GET_STUDY_GROUP_WEBINARS";
export const SET_STUDY_GROUP_WEBINARS = "SET_STUDY_GROUP_WEBINARS";
export const DELETE_STUDY_GROUP_WEBINARS = "DELETE_STUDY_GROUP_WEBINARS";
// export const GET_SPONSORS_REPRESENTATIVE = "GET_SPONSORS_REPRESENTATIVE";
// export const SET_SPONSORS_REPRESENTATIVE = "SET_SPONSORS_REPRESENTATIVE";

// export const GET_SPONSORS_REPRESENTATIVE_REQUESTS =
// "GET_SPONSORS_REPRESENTATIVE_REQUESTS";
// export const SET_SPONSORS_REPRESENTATIVE_REQUESTS =
// "SET_SPONSORS_REPRESENTATIVE_REQUESTS";
// export const CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS =
// "CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS";

export const JOIN_GROUP_FROM_LINK = "JOIN_GROUP_FROM_LINK";

export const CLEAR_TEMP_WEBINAR = "CLEAR_TEMP_WEBINAR";

export const GET_ADD_TO_CALLENDAR_LINKS = "GET_ADD_TO_CALLENDAR_LINKS";
export const SET_ADD_TO_CALLENDAR_LINKS = "SET_ADD_TO_CALLENDAR_LINKS";
export const CLEAR_ADD_TO_CALLENDAR_LINKS = "CLEAR_ADD_TO_CALLENDAR_LINKS";

export const GET_ADMIN_GROUP_MEMBERS = "GET_ADMIN_GROUP_MEMBERS";
export const SET_ADMIN_GROUP_MEMBERS = "SET_ADMIN_GROUP_MEMBERS";
export const SEND_GROUP_INVITES = "SEND_GROUP_INVITES";
export const GET_GROUP_INVITES = "GET_GROUP_INVITES";
export const SET_GROUP_INVITES = "SET_GROUP_INVITES";
export const DELETE_INVITE = "DELETE_INVITE";
export const DELETE_INVITE_SUCCESS = "DELETE_INVITE_SUCCESS";

export const GET_COURSE_MATERIALS = "GET_COURSE_MATERIALS";
export const SET_COURSE_MATERIALS = "SET_COURSE_MATERIALS";
export const CLEAR_COURSE_MATERIALS = "CLEAR_COURSE_MATERIALS";
export const CREATE_COURSE_MATERIAL = "CREATE_COURSE_MATERIAL";
export const UPDATE_COURSE_MATERIAL = "UPDATE_COURSE_MATERIAL";
export const SET_COURSE_MATERIAL = "SET_COURSE_MATERIAL";
export const DELETE_COURSE_MATERIALS = "DELETE_COURSE_MATERIALS";

export const GET_ZOOM_ACCOUNTS = "GET_ZOOM_ACCOUNTS";
export const SET_ZOOM_ACCOUNTS = "SET_ZOOM_ACCOUNTS";

export const DELETE_GROUP_MEMBER = "DELETE_GROUP_MEMBER";
export const DELETE_GROUP_INVITE = "DELETE_GROUP_INVITE";

export const USER_REQUEST_TO_JOIN_GROUP = "USER_REQUEST_TO_JOIN_GROUP";
export const USER_CANCEL_REQUEST_STUDY_GROUP =
  "USER_CANCEL_REQUEST_STUDY_GROUP";
export const UPDATE_STUDY_GROUP_REQUEST = "UPDATE_STUDY_GROUP_REQUEST";

export const CLEAR_STUDY_GROUPS = "CLEAR_STUDY_GROUPS";
export const USER_LEAVE_GROUP = "USER_LEAVE_GROUP";
export const ADMIN_GET_CERTIFICATES_USERS = "ADMIN_GET_CERTIFICATES_USERS";
export const ADMIN_SET_CERTIFICATES_USERS = "ADMIN_SET_CERTIFICATES_USERS";
export const ADMIN_CREATE_CERTIFICATES_USERS =
  "ADMIN_CREATE_CERTIFICATES_USERS";

export const ADMIN_CLEAR_CERTIFICATES_USERS = "ADMIN_CLEAR_CERTIFICATES_USERS";

export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";

export const LOAD_NOTIFICATIONS_COUNT = "LOAD_NOTIFICATIONS_COUNT";
export const SET_NOTIFICATIONS_COUNT = "SET_NOTIFICATIONS_COUNT";

export const MARK_NOTIFICATIONS = "MARK_NOTIFICATIONS";

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATIONS_INFINITE = "SET_NOTIFICATIONS_INFINITE";

export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

export const SEND_CONFIRM_CODE = "SEND_CONFIRM_CODE";
export const ADMIN_CONFIRM_LOGIN = "ADMIN_CONFIRM_LOGIN";
export const ADMIN_RESEND_CONFIRM_CODE = "ADMIN_RESEND_CONFIRM_CODE";
export const GET_QUESTIONS_ON_WEBINAR = "GET_QUESTIONS_ON_WEBINAR";
export const SAVE_QUESTIONS_ON_WEBINAR = "SAVE_QUESTIONS_ON_WEBINAR";
export const GET_GALLERY = "GET_GALLERY";
export const SAVE_GALLERY = "SAVE_GALLERY";
export const ADD_GALLERY = "ADD_GALLERY";
export const PUT_GALLERY = "PUT_GALLERY";
export const DELETE_GALLERY = "DELETE_GALLERY";
export const TOGGLE_GALLERY = "TOGGLE_GALLERY";

export const GET_SYSTEM_FEEDBACKS = "GET_SYSTEM_FEEDBACKS";
export const SET_SYSTEM_FEEDBACKS = "SET_SYSTEM_FEEDBACKS";
export const CLEAR_SYSTEM_FEEDBACKS = "CLEAR_SYSTEM_FEEDBACKS";

export const ADMIN_CREATE_SYSTEM_FEEDBACKS = "ADMIN_CREATE_SYSTEM_FEEDBACKS";
export const ADMIN_UPDATE_SYSTEM_FEEDBACKS = "ADMIN_UPDATE_SYSTEM_FEEDBACKS";
export const ADMIN_DELETE_SYSTEM_FEEDBACKS = "ADMIN_DELETE_SYSTEM_FEEDBACKS";

export const ADMIN_GET_SYSTEM_FEEDBACK_BY_ID =
  "ADMIN_GET_SYSTEM_FEEDBACK_BY_ID";

export const SET_SYSTEM_FEEDBACK = "SET_SYSTEM_FEEDBACK";

export const ADMIN_GET_SYSTEM_FEEDBACKS = "ADMIN_GET_SYSTEM_FEEDBACKS";

export const LOAD_CLIENT_URLS_SAGA_ADMIN = "LOAD_CLIENT_URLS_SAGA_ADMIN";
export const LOAD_CLIENT_URL_SAGA_ADMIN = "LOAD_CLIENT_URL_SAGA_ADMIN";
export const LOAD_CLIENT_URL_WEBINARS_SAGA_ADMIN =
  "LOAD_CLIENT_URL_WEBINARS_SAGA_ADMIN";
export const ADD_CLIENT_URLS_ADMIN = "ADD_CLIENT_URLS_ADMIN";
export const ADD_CLIENT_URL_ADMIN = "ADD_CLIENT_URL_ADMIN";
export const ADD_CLIENT_URL_WEBINARS_ADMIN = "ADD_CLIENT_URL_WEBINARS_ADMIN";
export const CREATE_CLIENT_URL_SAGA = "CREATE_CLIENT_URL_SAGA";
export const EDIT_CLIENT_URL_SAGA = "EDIT_CLIENT_URL_SAGA";
export const DELETE_CLIENT_URL_SAGA = "DELETE_CLIENT_URL_SAGA";
export const SET_TEMP_CLIENT_URL = "SET_TEMP_CLIENT_URL";

export const LOAD_CLIENT_URLS_SAGA = "LOAD_CLIENT_URLS_SAGA";
export const ADD_CLIENT_URLS = "ADD_CLIENT_URLS";
export const LOAD_CLIENT_WEBINARS_SAGA = "LOAD_CLIENT_WEBINARS_SAGA";
export const ADD_CLIENT_WEBINARS = "ADD_CLIENT_WEBINARS";



// WEBPACK FOOTER //
// ./src/constants/actions.js